import { authClient, API } from "../index";

export const getLogsTasacion = () => {
  return authClient().get(`${API}/logTasacion`);
};

export const countUnreadLogsTasacion = () => {
  return authClient().get(`${API}/logTasacion/count-unread`);
};

export const markLogsTasacionAsRead = () => {
  return authClient().patch(`${API}/logTasacion/mark-all-read`);
};

export const updateLogTasacion = (id, data) => {
  return authClient().patch(`${API}/logTasacion/${id}`, data);
};
